import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent
} from "@softline/dynamic";
import { LandeskennzeichenListView } from "./list-view/landeskennzeichen.list-view";
import { FieldOkSearchConfig } from '@softapps/core/pages';
import {LandeskennzeichenFieldOkSearchResultViewComponent} from './search-result-view/search-result-view.component';

export const landeskennzeichenFieldOk: FieldOkConfig = {
  name: 'landeskennzeichen',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{objekt}} - {{bezeichnung}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: LandeskennzeichenListView,
      sort: {
        properties: [
          {property: 'objekt', title: 'Objekt'},
        ]
      }
    }
  }
  ]
};
export const landeskennzeichenMultiselectFieldOk: FieldOkConfig = {
  name: 'landeskennzeichen',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{objekt}} - {{bezeichnung}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkMultiselectListViewComponent,
    title: 'Auswahl',
    config: {
      component: LandeskennzeichenListView,
      sort: {
        properties: [
          {property: 'objekt', title: 'Objekt'},
        ]
      }
    }
  }
  ]
};

export const landeskennzeichenQueryFieldOk: FieldOkConfig = {
  name: 'landeskennzeichen',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{objekt}} - {{bezeichnung}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: QueryFieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: LandeskennzeichenListView,
      sort: {
        properties: [
          {property: 'objekt', title: 'Objekt'},
        ]
      }
    }
  }
  ]
};

export const landeskennzeichenSearchPageConfig: FieldOkSearchConfig<any> = {
  name: 'landeskennzeichen',
  view: LandeskennzeichenFieldOkSearchResultViewComponent,
  options: {
    autoLoad: true
  }
}
